export default "__VITE_ASSET__DCPXZ07X__"